import { useEffect } from "react";

import { toolbarsActions, useDispatchToolbars } from "contexts/toolbars";

import { Toolbar } from "../Toolbar";
import { useToolsButtons } from "./useToolsButtons";

interface ToolsMenuToolbarProps {
    id?: string;
}

/**
 * Combined Measure and Section toolbar.
 * Measure button enables PointLine picker; Section button enables SectionPlane picker.
 */
export function ToolsMenuToolbar({ id = "tools-menu-toolbar" }: ToolsMenuToolbarProps) {
    const toolbarDispatch = useDispatchToolbars();
    const { buttons } = useToolsButtons();

    useEffect(() => {
        toolbarDispatch(toolbarsActions.addToolbar({ id, buttons }));

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, buttons]);

    return <Toolbar id={id} />;
}
